import { render, staticRenderFns } from "./StudyPartReportCollection.vue?vue&type=template&id=9d4e5d18&scoped=true&"
import script from "./StudyPartReportCollection.vue?vue&type=script&lang=ts&"
export * from "./StudyPartReportCollection.vue?vue&type=script&lang=ts&"
import style0 from "./StudyPartReportCollection.vue?vue&type=style&index=0&id=9d4e5d18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4e5d18",
  null
  
)

export default component.exports